import service from '@/services/superaccess'

const update = {
  state: {
    update_modal: false
  },
  mutations: {
    updateStatusUpdateModal (state, status) {
      state.update_modal = status
    }
  },
  getters: {
    getStatusUpdateModal (context) {
      return context.update_modal
    }
  },
  actions: {
    setStatusUpdateModal (context, payload) {
      context.commit('updateStatusUpdateModal', payload)
    },
    updateSystemFromCloud (context, payload) {
      return service.post('/api/configuration/update', context, { type: 'cloud' })
    }
  }
}

export default update



// WEBPACK FOOTER //
// app/javascript/src/store/update.js